import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {store} from '@/store/store';

import {RouterProvider} from 'react-router-dom';
import {router} from '@/app/router';
import {AppThemeProvider} from "@/app/AppThemeProvider";
import {ErrorBoundary} from "@/app/ErrorBoundary";


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <AppThemeProvider>
                <ErrorBoundary>
                    <RouterProvider router={router}/>
                </ErrorBoundary>
            </AppThemeProvider>
        </Provider>
    </React.StrictMode>
);